import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Grid } from "@material-ui/core";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CustomeTextField from "components/UpdateUi/CustomeTextField";
import ToastModal from "views/components/ToastModal";

const DesignationCreate = ({ classes }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { authToken } = useSelector((state) => state.login.authData);
  const [designation, setDesignation] = useState("");
  const [designationState, setDesignationState] = useState(false);
  const [level, setLevel] = useState("");
  const [levelState, setLevelState] = useState(false);
  const [callInProgress, setCallInProgress] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");

  const toastUpdate = (type, message, show) => {
    setToastMessageType(type);
    setToastMessage(message);
    setShowToast(show);
  };

  useEffect(() => {
    if (id) {
      getDesignationDetails();
    }
  }, [id]);

  const getDesignationDetails = async () => {
    setCallInProgress(true);

    const res = await apiHandler({
      url: endpoint.DESIGNATION_FINDALL,
      authToken,
    });

    setCallInProgress(false);

    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
    } else {
      const selectedDesignation = res?.data?.find(
        (item) => String(item?.id) === String(id)
      );

      if (selectedDesignation) {
        setDesignation(selectedDesignation?.designation || "");
        setLevel(selectedDesignation?.level || "");
      }
    }
  };

  const isValidated = () => {
    let valid = true;
    if (!designation) {
      setDesignationState(true);
      valid = false;
    } else {
      setDesignationState(false);
    }
    if (!level) {
      setLevelState(true);
      valid = false;
    } else {
      setLevelState(false);
    }
    return valid;
  };

  const saveDesignation = async () => {
  setCallInProgress(true);

  const payload = id
    ? {
        level: level.trim().toUpperCase(),
      }
    : {
        designation: designation.trim().toUpperCase(),
        level: level.trim().toUpperCase(),
      };

  const res = await apiHandler({
      url: id
        ? endpoint.DESIGNATION_UPDATE + id
        : endpoint.DESIGNATION_ADD,
      method: id ? "PUT" : "POST",
      authToken,
      data: payload,
    });

    setCallInProgress(false);

    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
    } else {
      toastUpdate(
        "Success",
        id
          ? "Designation updated successfully"
          : "Designation created successfully",
        true
      );
    }
  };

  const handleSubmit = () => {
    if (isValidated()) {
      saveDesignation();
    }
  };

  const handleCancel = () => {
    navigate("/coreservice/designation");
  };

  const handleToastClose = () => {
    setShowToast(false);
    if (toastMessageType === "Success") {
      navigate("/coreservice/designation");
    }
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        <SubHeader
          label={id ? "Update Designation" : "Create Designation"}
          button1="Save"
          button2="Cancel"
          button1click={handleSubmit}
          button2click={handleCancel}
        />
      </Grid>
      <Grid item xs={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Designation"
              disabled={!!id}
              required
              error={designationState}
              id="designation"
              value={designation}
              setState={setDesignation}
              setError={setDesignationState}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Level"
              required
              error={levelState}
              id="level"
              value={level}
              setState={setLevel}
              setError={setLevelState}
            />
          </Grid>
        </Grid>
      </Grid>
      {callInProgress && <CircularProgresss callInProgress />}
      {showToast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={handleToastClose}
        />
      )}
    </Grid>
  );
};

export default DesignationCreate;
